// Generated by CoffeeScript 2.7.0
Array.prototype.groupByLength = function(length = 1) {
  var arr, results;
  arr = this.slice(0);
  results = [];
  while (arr.length > 0) {
    results.push(arr.splice(0, Math.min(length, arr.length)));
  }
  return results;
};

Array.wrap = function(array) {
  if (array instanceof this) {
    return array;
  } else {
    return [array];
  }
};
